import { LOGO, PAYMENT_METHODS } from "../lib/api";

export const Footer = () => (
  <footer className="bg-[#1A1714] text-[#E8DCC8] mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-2">
          <img src={LOGO} alt="" className="w-10 h-10 rounded-full object-cover scale-110" />
          <span className="font-display text-2xl font-extrabold">Afri<span className="text-[#D99B26]">-go</span></span>
        </div>
        <p className="text-sm text-stone-400 mt-4 max-w-xs">The marketplace built for Africa. From Nairobi to Lagos, Harare to Accra.</p>
      </div>
      <div>
        <h4 className="font-display font-bold mb-3">We accept</h4>
        <div className="flex flex-wrap gap-2">
          {PAYMENT_METHODS.map((m) => <span key={m.id} className="text-xs px-3 py-1.5 rounded-full border border-white/15">{m.name}</span>)}
        </div>
      </div>
      <div>
        <h4 className="font-display font-bold mb-3">Delivering to</h4>
        <p className="text-sm text-stone-400">Kenya · Nigeria · South Africa · Ghana · Zimbabwe · Uganda · Tanzania · Rwanda · Zambia and more</p>
      </div>
    </div>
    <div className="text-center text-xs text-stone-500 pb-8">© 2026 Afri-go. Made with pride for the motherland.</div>
  </footer>
);
